import React from 'react';
import { useParams } from 'react-router';
import { MainView } from '@repo/ui/Views';
import { FallbackCard } from '@repo/ui/Card';
import { useUser } from '@repo/hooks/useUser';

import { Authorization, POLICIES } from '@/lib/Authorization';
import { useAccount } from '@/hooks/useAccount';
import { FilterRestoreGate } from '@/components/FilterRestoreGate';
import SwitchesForAccountTable, {
  ACCOUNT_SWITCHES_TABLE_KEY,
} from '../components/SwitchesForAccountTable';
import CreateSwitchSheet from '../components/CreateSwitchSheet';
import { SWITCH_EXPLANATION } from '../consts';

const AccountSwitches = () => {
  const { accountId } = useParams();
  const user = useUser();

  const account = useAccount();

  return (
    <MainView title={`${account?.name} Message Forwarding`} description={SWITCH_EXPLANATION}>
      <Authorization
        policyCheck={POLICIES['switches:index'](user)}
        fallbackView={<FallbackCard description="You do not have permissions to view switches." />}
      >
        {accountId && POLICIES['switches:create'](user) && (
          <div className="flex justify-end">
            <CreateSwitchSheet accountId={accountId} />
          </div>
        )}
        {accountId && (
          <FilterRestoreGate tableKey={ACCOUNT_SWITCHES_TABLE_KEY}>
            <SwitchesForAccountTable accountId={accountId} />
          </FilterRestoreGate>
        )}
      </Authorization>
    </MainView>
  );
};

export default AccountSwitches;
